import React from 'react';
import ItemCounts from '../ItemCounts';
import SectionHeader from '../../Basic/SectionHeader';
import CheckBox from '../../Basic/CheckBox';
const GasAppliances = ({ isDuplex, address, nameExt }) => {
    const lookup = window.osa.lookup.projectSpecifics.gasAppliances;
    let name = "notSure" + (nameExt || "");
    let title = lookup.title;
    if (isDuplex) {
        title = lookup.titleDuplex.replace('{Address}', address);
    }
    return (
        <div className="form-group">
            <SectionHeader title={title} />
            <p dangerouslySetInnerHTML={{ __html: lookup.text }} />
            <div className="row">
                <div className="col-sm-4">
                    <CheckBox name={name} title={lookup.notSure} />
                </div>
            </div>
            <ItemCounts items={lookup.items} placeholder="0" nameExt={nameExt} />
        </div>
    );
};
GasAppliances.propTypes = {
    isDuplex: React.PropTypes.bool,
    address: React.PropTypes.string,
    nameExt: React.PropTypes.string,
};
export default GasAppliances;